import { getCookie, setCookie } from "@trustpilot/businessapp-browserstorage";

import configuration from "../configuration";

export const BUSINESSUNIT_COOKIE = "tp-b2b-selected-business-unit-id";
export const ISSSOAUTHENTICATED_COOKIE = "tp-b2b-is-sso-saml-authenticated";
export const LANGUAGE_COOKIE = "tp-b2b-current-language";
export const SSOAUTHENTICATED_BUSINESSACCOUNTID_COOKIE = "tp-b2b-sso-saml-authenticated-business-account-id";
export const SSOAUTHENTICATED_RECENTLY_COOKIE = "tp-b2b-sso-saml-recently-authenticated";

export interface AppCookies {
  [BUSINESSUNIT_COOKIE]?: string;
  [LANGUAGE_COOKIE]?: string;
}

export function getCurrentBusinessUnitId() {
  return getCookie(BUSINESSUNIT_COOKIE);
}

export function setCurrentBusinessUnitId(businessUnitId: string) {
  setCookie(BUSINESSUNIT_COOKIE, businessUnitId, {
    path: "/",
    maxAge: 60 * 60 * 24 * 365,
    domain: configuration.CookieDomain,
  });
}

// temp duplicate of getCookie from businessapp-browserstorage, needed to bypass desired cookie not being on OneTrust whitelist
export const getCookieByName = (name: string): string => {
  const re = new RegExp(`(?:(?:^|.*;\\s*)${name}\\s*\\=\\s*([^;]*).*$)|^.*$`, "g");
  const value = document.cookie.replace(re, "$1");
  return value;
};

export function getCurrentLocale() {
  return getCookie(LANGUAGE_COOKIE);
}

export function setCurrentLocale(locale: string) {
  setCookie(LANGUAGE_COOKIE, locale, {
    domain: configuration.CookieDomain,
    path: "/",
    maxAge: 60 * 60 * 24 * 365, // one year
  });
}
